export default (node) => {
  const tabs = node.querySelectorAll('[data-tab]');
  const contentBlocks = node.querySelectorAll('[data-content]');

  // Function to show content based on tab index
  const showContent = (index) => {
    // Hide all content blocks
    contentBlocks.forEach((block) => block.classList.add('hidden'));

    // Show the selected content block
    const selectedContent = node.querySelector(`[data-content="${index}"]`);
    if (selectedContent) {
      selectedContent.classList.remove('hidden');
    }

    // Reset all tabs to inactive state
    tabs.forEach((tab) => {
      tab.classList.remove('active-tab');
      tab.classList.add('text-text-tertiary');
    });

    // Set the selected tab to active state
    const selectedTab = node.querySelector(`[data-tab="${index}"]`);
    if (selectedTab) {
      selectedTab.classList.add('active-tab');
      selectedTab.classList.remove('text-text-tertiary');
    }
  };

  // Add click event listeners to tabs
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => showContent(index + 1));
  });

  // Initialize by showing the first content block
  showContent(1);
};
